import { render } from "./Create.vue?vue&type=template&id=967994d4"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=967994d4&lang=css"
script.render = render

export default script